import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { TextField, Button, Typography, Grid, InputLabel, CircularProgress } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/logo.jpg";
import "../components/App.css";
import axios from "axios";
import toast from "react-hot-toast";
import { API_BASE_URL } from "../config/config";
import BevHeader from "../components/BevHeader";
import BevFooter from "../components/BevFooter";
import PasswordField from "../components/PasswordField";

const Login = () => {
  const navigate = useNavigate();

  const handleLogin = async (values, { setSubmitting }) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/login`, values);
      const { token } = response.data;

      localStorage.setItem("care_token", token);

      navigate("/user/dashboard");
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Login failed. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <BevHeader />
      <div className="login-container">
      <div className="login-form">
      <img src={Logo} alt="Logo" width={120} className="form-logo" />
      <Typography variant="h6" component="h2" gutterBottom textAlign="center" marginBottom="20px" paddingBottom="10px" borderBottom="1px solid #ccc">
          Welcome to Bevogtet, Login below!
        </Typography>
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        validationSchema={Yup.object({
          email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
          password: Yup.string()
            .required("Password is required")
            .min(8, "Password must be at least 8 characters"),
        })}
        onSubmit={handleLogin}
      >
        {({ isSubmitting }) => (
         <Form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InputLabel htmlFor="email">Email</InputLabel>
              <Field
                as={TextField}
                name="email"
                size="small"
                variant="outlined"
                fullWidth
                disabled={isSubmitting}
              />
              <ErrorMessage name="email" component="div" className="login-error" />
            </Grid>
            <Grid item xs={12}>
              <InputLabel htmlFor="password">Password</InputLabel>
              <Field
                name="password"
                component={PasswordField}
                size="small"
                variant="outlined"
                fullWidth
                disabled={isSubmitting}
              />
              <ErrorMessage
                name="password"
                component="div"
                className="login-error"
              />
              <div className="forgot-password-link">
                <Link className="login-link" to="/forgot-password">Forgot Password?</Link>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="success"
                fullWidth
                disabled={isSubmitting}
                startIcon={
                  isSubmitting ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : null
                }
              >
                {isSubmitting ? "Logging in..." : "Login"}
              </Button>
            </Grid>
            <Grid item xs={12} className="login-links">
              <p className="login-register-text">
                New here? <Link className="login-link" to="/">Register</Link>
              </p>
            </Grid>
          </Grid>
        </Form>
        )}
      </Formik>
      </div>
    </div>
      <BevFooter />
    </>
  );
};

export default Login;
